/**
 * Conversions for `<input type="datetime-local">`.
 *
 * The control speaks wall-clock with no zone; the API speaks UTC ISO.
 * Always interpret wall-clock in the user's Chronos timezone (not the
 * browser's) so editing due/Start-after cannot shift by hours when the
 * laptop TZ differs from America/Chicago (or whatever is configured).
 */

import { DateTime } from 'luxon';

export function toLocalInput(iso: string | null, timezone: string): string {
  if (!iso) return '';
  return DateTime.fromISO(iso, { zone: 'utc' }).setZone(timezone).toFormat("yyyy-LL-dd'T'HH:mm");
}

export function fromLocalInput(value: string, timezone: string): string | null {
  if (!value) return null;
  const dt = DateTime.fromFormat(value, "yyyy-LL-dd'T'HH:mm", { zone: timezone });
  if (!dt.isValid) return null;
  return dt.toUTC().toISO();
}
